import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Box,
  Typography,
  Container,
  CssBaseline,
  TextField,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import logo from "../assets/images/logo.png";
import { Context as AuthContext } from "../context/AuthContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(10),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  container: {
    backgroundColor: "#e9f0f6",
    borderRadius: 20,
    height: "500px",
    [theme.breakpoints.down("sm")]: {
      width: "75%",
      marginTop: 80,
      backgroundColor: "#e9f0f6",
    },
  },
  image: {
    margin: theme.spacing(1),
    width: 100,
    height: 100,
  },
  form: {
    width: "80%",
    marginTop: theme.spacing(1),
  },
  button_login: {
    background: "linear-gradient(45deg, #000000 30%, #3A3B3F 90%)",
    border: 0,
    borderRadius: 3,
    boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
    color: "white",
    height: 42,
    padding: "0 30px",
    marginTop: "4%",
    "&:disabled": {
      background: "#9e9e9e",
      color: "#e0e0e0",
      boxShadow: "none",
    },
  },
}));

const Login = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { state, loginUser, clearLoginUser } = useContext(AuthContext);

  useEffect(() => {
    if (state.LoginStatus === 200) {
      setIsLoading(false);
      navigate("/home");
      clearLoginUser();
    }
    else if (state.LoginStatus !== "" && state.LoginStatus !== 200) {
      setIsLoading(false);
      setErrorMessage(
        state.LoginError || "An error occurred during login. Please try again.",
      );
      setOpen(true);
      clearLoginUser();
    }
  }, [state.LoginStatus, state.LoginError, navigate, clearLoginUser]);

  const handleLogin = () => {
    if (userName === "" || password === "") {
      setErrorMessage("Please enter both email and password.");
      setOpen(true);
    } else {
      setIsLoading(true);
      loginUser({ email: userName.toLowerCase(), password: password });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <Container component="main" maxWidth="xs" className={classes.container}>
      <CssBaseline />
      <div className={classes.paper}>
        <img src={logo} className={classes.image} alt="logo" />
        <Typography component="h3" variant="h6">
          Welcome to Social Paws
        </Typography>
        <div className={classes.form}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="user_name"
            label="Email Address"
            autoComplete="email"
            autoFocus
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            disabled={isLoading}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoading}
          />

          <Button
            fullWidth
            variant="contained"
            className={classes.button_login}
            onClick={() => handleLogin()}
            disabled={isLoading}
          >
            {isLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Sign In"
            )}
          </Button>
        </div>
      </div>
      <Box mt={8}>
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          style={{ marginTop: "-40px" }}
        >
          All Rights Reserved.
        </Typography>
      </Box>

      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Login;
